import BetModel from "../model/BetModel";
import Layout from "../utils/Layout";
import BaseView from "./BaseView";
import Utils from "../utils/Utils";
import { TweenMax } from "gsap";
import { IObjectConfig } from "../baseConfigs/layoutConfigShema";

type TextFontSizes = {
    money: number,
    cents: number,
    currency: number
}

export abstract class AbstractMoneyField extends BaseView {

    // private money: number;
    // protected moneyText: PIXI.Text;
    // protected centsText: PIXI.Text;
    // protected currencyText: PIXI.Text;
    // private boundsRect: PIXI.Graphics;
    protected _config: MoneyFieldConfig;

    constructor(config?: MoneyFieldConfig) {
        super();
        if (!config) {
            this._config = new MoneyFieldConfig();
        } else {
            this._config = config;
        }

        // this.createBoundsRect();
        // this.createTextfields();
    }



    abstract get bounds(): { width: number, height: number };
    abstract set bounds(bounds: { width: number, height: number });

    public abstract clone():AbstractMoneyField;

    protected abstract positionText();

    public abstract rescale(bounds:IObjectConfig);

    public centerVertical() {
        console.warn("NO VERICAL CENTERING AVAILABLE");
    }

    abstract set value(value: number);
    abstract get value(): number;

    abstract set style(style: PIXI.TextStyleOptions);



}


export class MoneyFieldConfig implements IMoneyFieldConfig {
    currencyRelativeSize: number = 50;
    centsRelativeSize: number = 60;
    moneyFontSize: number = 60;
    minFontSize: number = 10;
    fontFamily: string = "Arial";
    bounds = {
        width: 400,
        height: 200
    };
    debug: boolean = false;
    align: string = "center";
    shouldFitToBounds: boolean = true;
    alignOnlyMoney: boolean = false;
    keepCurrencySize: boolean = true;
    spaceBetweenThousands: boolean = false;
    symbolBetweenThousands: string = " ";
    decimalSeparatorSymbol: string = ".";
    prependSymbol: boolean = false;
    showIdentifier: boolean = true; // whether to show Currency name
    showSymbol = false; // if set to true currency symbol will be visualized, else ISO will be used
    hideWhenZero: boolean = false;
    centerAlignOnlyMoney: boolean = false; // todo implement !!!
    currency = "USD";

    constructor(vars?: IMoneyFieldConfig) {
        if (vars) {
            Utils.serialize(vars, this);
        }
    }
}

export interface IMoneyFieldConfig {
    currencyFontSize?: number;
    centsFontSize?: number;
    moneyFontSize?: number;
    minFontSize?: number;
    fontFamily?: string;
    bounds?: {
        width: number,
        height: number
    };
    debug?: boolean;
    align?: string;
    shouldFitToBounds?: boolean;
    alignOnlyMoney?: boolean;
    keepCurrencySize?: boolean;
    spaceBetweenThousands?: boolean;
    symbolBetweenThousands?: string;
    decimalSeparatorSymbol?: string;
    prependSymbol?: boolean;
    showIdentifier?: boolean;
    hideWhenZero?: boolean;
    currency?: string;
}


